export interface CategoryShortcut {
  key: string;
  label: string;
  icon: string;
  type: string;
  desc: string;
}

export const categoryShortcuts: CategoryShortcut[] = [
  {
    key: "new",
    label: "最新动画",
    icon: "ri-movie-2-line",
    type: "最新",
    desc: "近期上线的全新作品",
  },
  {
    key: "hot",
    label: "热门推荐",
    icon: "ri-fire-line",
    type: "热门",
    desc: "人气最高的动画作品",
  },
  {
    key: "pick",
    label: "动画电影",
    icon: "ri-film-line",
    type: "推荐",
    desc: "精选编辑推荐佳作",
  },
  {
    key: "comic",
    label: "漫画相关",
    icon: "ri-book-open-line",
    type: "资讯",
    desc: "作品与资讯动态合集",
  },
];

export const regionOptions = ["全部", "日本", "国内", "欧美"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022及以前"];

export const genreOptions = [
  "全部",
  "动作",
  "奇幻",
  "科幻",
  "日常",
  "悬疑",
  "治愈",
  "青春",
  "冒险",
  "热血",
];

export const sortOptions = [
  { key: "latest", label: "最新" },
  { key: "hot", label: "最热" },
];

export const newsCategoryOptions = [
  "全部",
  "行业动态",
  "作品资讯",
  "活动公告",
  "展会信息",
];

export interface CategoryMeta {
  name: string;
  title: string;
  description: string;
  keywords: string;
  intro: string;
}

export const categoryMeta: Record<string, CategoryMeta> = {
  最新: {
    name: "最新",
    title: "58动漫 - 最新动漫作品列表",
    description:
      "浏览 58动漫最新上线的动漫作品，支持按地区、年份、类型筛选与排序，快速找到近期值得关注的新番动画。",
    keywords: "最新动漫,新番动画,最新动画作品,58动漫,动漫列表",
    intro: "近期上线的全新动画作品，按上线时间排序，第一时间了解新番动态。",
  },
  热门: {
    name: "热门",
    title: "58动漫 - 热门动漫作品列表",
    description:
      "查看 58动漫人气最高的热门动画作品，按评分与热度排序，了解当下最受关注的动漫推荐。",
    keywords: "热门动漫,人气动画,高分动漫,动漫推荐,58动漫",
    intro: "根据评分与关注度综合排序的人气作品，看看大家都在追什么。",
  },
  推荐: {
    name: "推荐",
    title: "58动漫 - 推荐动漫作品列表",
    description:
      "58动漫编辑精选推荐动画作品，涵盖奇幻、治愈、科幻等多种题材，帮你发现更多值得一看的佳作。",
    keywords: "动漫推荐,动画佳作,精选动漫,治愈动画,58动漫",
    intro: "由编辑精选的优质作品，题材丰富，适合想发现好片的你。",
  },
  资讯: {
    name: "资讯",
    title: "58动漫 - 资讯相关动漫作品列表",
    description:
      "与最新资讯动态相关联的动漫作品合集，按相关资讯数量排序，边看新闻边了解作品。",
    keywords: "动漫资讯,作品动态,动漫新闻,相关作品,58动漫",
    intro: "与近期资讯动态关联度较高的作品，边看新闻边了解作品。",
  },
};

export const getCategoryMeta = (type: string): CategoryMeta => {
  return (
    categoryMeta[type] || {
      name: type || "全部",
      title: `58动漫 - ${type || "全部"}动漫作品列表`,
      description:
        "浏览 58动漫动画作品列表，支持按地区、年份、类型筛选与排序，帮助你快速找到想看的动漫。",
      keywords: "动漫作品,动画列表,动漫筛选,58动漫",
      intro: "浏览全部动画作品，支持多维筛选与排序。",
    }
  );
};